import { createStore } from "vuex";

export default createStore({
  state: {
    step: 1,
    bank_account_number: "",
    employee_number: "",
    abaNumber: "",
    bank_account_type: "",
    bankName: "",
    employee_name: "",
    sign_value: "",
    Master_Account_Name: "",
    selectedOption: "",
    checkbox: false,
    lock_value: "",
    account_number: "",
    myenroll_url: "",
    service_email: "",
    url_name: "",
    service_phone: "",
    is_auto_ach_account: false,
    autoachText: "",
    autoachText_word1: "",
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
